import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { BasicStepOneComponent } from '../basic-step-one/basic-step-one.component';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/shared/services/language.service';
import { StepOneControllers } from './types';
import { BasicStepOneTemplateService } from '../../services/basic-step-one-template.service';

@Component({
  selector: 'app-basic-info',
  templateUrl: './basic-info.component.html',
  styleUrls: ['./basic-info.component.scss'],
})
export class BasicInfoComponent implements OnInit, AfterViewInit {
  @ViewChild(BasicStepOneComponent) stepOne!: BasicStepOneComponent;


  constructor(
    private languageService: LanguageService,
    private basicStepOneTemplateService: BasicStepOneTemplateService,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.translate.use(localStorage.getItem('language'));
    this.languageService.languageUpdated.subscribe((lang: string) => {
      this.translate.use(lang);
    });
  }

  async ngAfterViewInit() {
    await this.stepOne.asyncUpdateForm();
    const formValue = await this.basicStepOneTemplateService.getObjectToPatch();
    if (formValue) this.applyValuesToFields(formValue);
  }

  async clearFormData() {
    this.stepOne.stepForm.reset();
  }

  async restData(){
    try{
      await this.basicStepOneTemplateService.postData(null);
      this.clearFormData();
      this.basicStepOneTemplateService.showSuccessPopup('FORM_TEMPLATE.RESET_SUCCESS');
    }catch(e){
      this.basicStepOneTemplateService.showFailPopup();
    }
  }

  async save() {
    try {
      const formValue = this.stepOne.stepForm.value;
      await this.basicStepOneTemplateService.postData(formValue);
      this.basicStepOneTemplateService.showSuccessPopup();
    } catch (e) {
      this.basicStepOneTemplateService.showFailPopup();
    }
  }

  public applyValuesToFields(data: StepOneControllers) {
    this.stepOne.stepForm.patchValue(data);
  }
}
